export default __webpack_public_path__ + "static/media/White Hand Witchweaves.bed4c854.jpg";